import {computed, type Ref} from "vue";
import {useQuery} from "@tanstack/vue-query";
import {useSessionStore} from "@/stores/session-store";
import {subscriptionsApi, type ProductSubscription} from "@/services/subscriptions";
import type {ApiError} from "@/helpers/api-error";

// READ — subscriptions owned by the current org (raw subscription rows with dates + active flag).
// Pair with `useSubscribedProducts()` from queries/products.ts to join product metadata.
export function useOrgSubscriptions() {
    const sessionStore = useSessionStore();
    const orgId = computed(() => sessionStore.session?.currentOrg?.orgId as string | undefined);

    const {data, isFetching: subscriptionsLoading, error: subscriptionsError} = useQuery({
        queryKey: ["org-subscriptions", orgId],
        queryFn: () => subscriptionsApi.getOrgSubscriptions(orgId.value!),
        enabled: computed(() => !!orgId.value),
    });
    const subscriptions = computed<ProductSubscription[]>(() => data.value ?? []);

    return {
        subscriptions,
        subscriptionsLoading,
        subscriptionsError: subscriptionsError as Ref<ApiError | null>,
    };
}
